class GetContextResourceError extends Error {
  constructor(reason) {
    super()
    this.name = 'GetContextResourceError'
    this.message = `Failed to get the Context resource${reason ? `, reason: ${reason}` : '.'}`
  }
}

export default GetContextResourceError
